'use client'

import type { ReactNode } from 'react'
import Link from 'next/link'
import { tracking } from '@/tracking'

export function TrackedCarouselLink({
  brandCode,
  children,
  href,
  itemId,
  itemName,
  position,
}: TrackedCarouselLinkProps) {
  return (
    <Link
      href={href}
      prefetch={false}
      aria-label={`View ${itemName}`}
      className="block h-full w-full focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-white"
      onClick={() =>
        tracking.track('Clicked homepage carousel', {
          'Brand code': brandCode,
          'Carousel item ID': itemId,
          'Carousel item name': itemName,
          Position: position,
          Url: href,
        })
      }
    >
      {children}
    </Link>
  )
}

interface TrackedCarouselLinkProps {
  brandCode: string
  children: ReactNode
  href: string
  itemId: string
  itemName: string
  position: number
}
